import { format } from 'date-fns'

function formatYearMonthDate(date) {
  if (!date) return date

  return format(date, 'YYYY-MM-DD')
}

export default formatYearMonthDate
